/**
 * P0.3 — Authentification API centralisée.
 *
 * Attache automatiquement le header X-Session-Token (depuis localStorage) à
 * toutes les requêtes vers NOTRE backend, qu'elles passent par axios ou par
 * fetch. Nécessaire depuis que les endpoints /api/admin/* et /api/v1/admin/*
 * sont protégés côté serveur : la plupart des pages admin n'envoyaient pas le
 * token individuellement.
 *
 * Le token n'est JAMAIS envoyé vers un domaine tiers : seules les URLs
 * relatives ou commençant par REACT_APP_BACKEND_URL sont instrumentées.
 *
 * Importer une seule fois, au démarrage (index.js).
 */
import axios from "axios";

const TOKEN_KEY = "lemaitremot_session_token";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const isOwnApi = (url) => {
  if (typeof url !== "string") return false;
  if (url.startsWith("/")) return true; // URL relative => même origine
  return BACKEND_URL !== "" && url.startsWith(BACKEND_URL);
};

const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

// --- axios ---------------------------------------------------------------
axios.interceptors.request.use((config) => {
  const url = config.baseURL ? `${config.baseURL}${config.url || ""}` : config.url;
  const token = getToken();
  if (token && isOwnApi(url) && !config.headers?.["X-Session-Token"]) {
    config.headers = config.headers || {};
    config.headers["X-Session-Token"] = token;
  }
  return config;
});

// --- fetch ---------------------------------------------------------------
const originalFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url;
  const token = getToken();
  if (token && isOwnApi(url)) {
    const headers = new Headers(
      init.headers || (typeof input !== "string" ? input?.headers : undefined) || {}
    );
    if (!headers.has("X-Session-Token")) {
      headers.set("X-Session-Token", token);
    }
    return originalFetch(input, { ...init, headers });
  }
  return originalFetch(input, init);
};
